module.exports = __webpack_public_path__ + "static/media/logo-wu.b3f6c2b3.svg";